import React from 'react'
import Container from '../container/Container'
import Header from 'components/header/pageHeader/Header'
import Button from 'components/button/Button'

import getBetReply from './helperFunctions/getBetReply'
import BetReplyContent from './elements/BetReplyContent'

import { Main } from './BetReplyStyled'
import { BETREPLY_PROPS } from './interface'
import Loader from './loader/Loading'
import { Notifications } from 'index'
import SFXS from '../../assets/audios/audios'

export default function BetReply({
  children,
  colors,
  handleAbove,
  handleNotification,
  betReplyResponse,
  roundId,
  audio,
  toFix,
  betInfo,
  size,
  mainPadding,
  topPadding,
  headerpadding,
}: BETREPLY_PROPS) {
  const { BET_ID, BET_INFO, SEED } = getBetReply(betReplyResponse, toFix)

  const clickHandler = () => {
    setTimeout(() => {
      handleAbove('History')
    }, 300)
  }

  const handleReturnToPage = () => {
    handleNotification(Notifications.notFound)
    setTimeout(() => {
      handleAbove('History')
    }, 300)
  }

  return (
    <Container
      textColor={colors.primaryText}
      backgroundColor={colors.primary}
      unBlur={false}
      styles={{ padding: topPadding || '30px 0' }}
    >
      <Header
        name='Bet Reply'
        strokeColor={colors.closeStrokeColor}
        background={colors.secondary}
        borderColor={colors.primaryText}
        handleAbove={handleAbove}
        styles={{ padding: headerpadding || '30px 0' }}
        audio={audio}
      />
      <Main mainPadding={mainPadding}>
        {betReplyResponse && betReplyResponse.round_id === roundId ? (
          <BetReplyContent
            content={{ BET_ID, BET_INFO, SEED }}
            func={handleNotification}
            children={children}
            colors={colors}
            betInfo={betInfo}
          />
        ) : (
          <Loader colors={colors} handleReturnToPage={handleReturnToPage} />
        )}

        <Button
          width='100%'
          func={() => clickHandler()}
          audio={audio}
          SFX={SFXS.confirmSFX}
          background={colors.secondary}
          textColor={colors.tertiaryDark}
          size={size}
        >
          OK
        </Button>
      </Main>
    </Container>
  )
}
